import { render, staticRenderFns } from "./BudgetProjectionEvaluation.vue?vue&type=template&id=316771c2&"
import script from "./BudgetProjectionEvaluation.vue?vue&type=script&lang=js&"
export * from "./BudgetProjectionEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports